import { useContext } from 'react';
import ConstantsContext from '../contexts/ConstantsContext';

const useConstants = () => useContext(ConstantsContext);

export default useConstants;
